import { Component, OnInit, TemplateRef } from '@angular/core';
import { WithSearchBarAndSieve } from '../../../helpers/base-classes/withSearcBarAndSieve.class';
import { ToastrService } from 'ngx-toastr';
import { DataService } from '../../../services/data.service';
import { NgbModal, NgbModalConfig, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectConfig } from '@ng-select/ng-select';
import { NotificationService } from '../../../services/notification.service';
import { AutocompleteService } from '../../../services/autocomplete.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { IUserWithAnagraphic } from '../../../models/request-and-responses/rest-api/interfaces/userWithAnagraphic';
import { ISieveFilterObject, SieveOperator, SieveString } from '../../../helpers/sieve/sieveString.class';
import { PataviumRole } from '../../../models/request-and-responses/rest-api/enums/role.enum.model';
import { AnagraphicType } from '../../../models/request-and-responses/rest-api/enums/anagraphicType.enum';
import { IUserWithAnagraphicGroup } from '../../../models/request-and-responses/rest-api/interfaces/userWithAnagraphicGroup';
import { IUserInfoCreate } from '../../../models/request-and-responses/rest-api/interfaces/userInfoCreate';
import { AttachType } from '../../../models/request-and-responses/rest-api/enums/attachType';
import { ContractPermission } from '../../../models/request-and-responses/rest-api/enums/contractPermission';
import { AuthService } from '../../../services/auth.service';
import { LocalStorageService } from '../../../services/local-storage.service';
import { BrandType } from '../../../models/request-and-responses/rest-api/enums/brandType';
import { EMPTY, Subscription } from 'rxjs';
import { CustomerVisibilityType } from '../../../models/request-and-responses/rest-api/enums/customerVisibility';
import { SessionStorageService } from '../../../services/session-storage.service';
import { SieveFilter, SieveSort } from '../../../helpers/sieve/sieve-filters-and-sorts';
import { UserInfoCreate } from '../../../models/request-and-responses/rest-api/classes/userInfoCreate';
import { UserWithAnagraphicGroup } from '../../../models/request-and-responses/rest-api/classes/userWithAnagraphicGroup';
import { IVeryShortUser } from '../../../models/request-and-responses/rest-api/interfaces/veryShortUser';
import { IPageConfig } from '../../../models/frontend/page-config';
import { LocalStorageKey } from '../../../models/frontend/local-storage.key';
import { IDropdownSettings } from 'ng-multiselect-dropdown/multiselect.model';
import { catchError, finalize, tap, take } from 'rxjs/operators';
import { IPairAnagraphicUserRole } from '../../../models/request-and-responses/rest-api/interfaces/pairAnagraphicUsersRoles';

export enum ActionUser {
    Create = 0,
    Edit = 1,
    Info = 2,
    Link = 3
}

@Component({
    selector: 'app-userlist',
    templateUrl: './userlist.component.html',
    styleUrls: ['./userlist.component.css']
})
export class UserlistComponent extends WithSearchBarAndSieve implements OnInit {
    SieveSort = SieveSort;
    ActionUser = ActionUser;
    PataviumRole = PataviumRole;
    public showBanUsers = false;
    protected preferredGroup: number = null;
    protected preferredPermitContract: ContractPermission = null;
    public users: IUserWithAnagraphic[];
    public availableGroups: IVeryShortUser[] = [];
    public element: IUserWithAnagraphic;
    public editUser: IUserWithAnagraphicGroup;
    public createUser: IUserInfoCreate;
    public infoUser: IUserWithAnagraphic;
    public linkUser: IUserWithAnagraphic;
    linkedCustomers: IPairAnagraphicUserRole[] = [];
    isInLoad = false;
    progressLink: number = null;
    checkAll = false;
    public infoIdentityAttLabel: string[];
    public infoContractAttLabel: string[];
    public removeUser: IUserWithAnagraphic;
    private modalRef: NgbModalRef;
    private selectConf: Object = {};
    isInitFinished = true;
    userlistSubscription: Subscription;
    public isSavingUser = false;
    public dropdownSettings: IDropdownSettings = {
        singleSelection: false,
        idField: 'value',
        textField: 'name',
        selectAllText: 'Seleziona tutto',
        unSelectAllText: 'Deseleziona tutto',
        itemsShowLimit: 3
    };
    public optAttachmentsIdentitySelected = [];
    public optAttachmentsContractSelected = [];
    public brandAvailableSelected = [];
    public brandAvailable = [];
    public readonly optAttachmentsIdentity = [
        {
            name: "Carta d'identità",
            value: Number(AttachType.CartaIdentita)
        },
        {
            name: "Carta d'identità elettronica",
            value: Number(AttachType.CartaIdentitaElettronica)
        },
        {
            name: 'Passaporto',
            value: Number(AttachType.Passaporto)
        },
        {
            name: 'Patente',
            value: Number(AttachType.Patente)
        },
        {
            name: 'Altro documento di riconoscimento',
            value: Number(AttachType.RiconoscimentoGenerico)
        }
    ];
    public readonly optAttachmentsContract = [
        {
            name: 'Dati catastali',
            value: Number(AttachType.DatiCatastali),
            checked: false
        },
        {
            name: 'Richiesta fornitura',
            value: Number(AttachType.RichiestaFornitura)
        },
        {
            name: 'Contratto cartaceo',
            value: Number(AttachType.ContrattoCartaceo)
        },
        {
            name: 'Condizioni economiche',
            value: Number(AttachType.CondizioniEconomiche)
        },
        {
            name: 'File audio firma',
            value: Number(AttachType.FileAudioFirma)
        },
        {
            name: 'Documento d\'identità e codice fiscale',
            value: Number(AttachType.CodiceFiscale)
        },
        {
            name: 'Ultima bolletta',
            value: Number(AttachType.UltimaBolletta)
        },
        {
            name: 'Visura camerale (solo Business)',
            value: Number(AttachType.VisuraCamerale)
        },
        {
            name: 'Agevolazioni',
            value: Number(AttachType.IvaAgevolata)
        },
        {
            name: 'Identificazione del servizio di ultima istanza',
            value: Number(AttachType.ServizioUltimaIstanza)
        },
        {
            name: 'Documento o autocertificazione legittima occupazione immobile',
            value: Number(AttachType.LegittimaOccupazione)
        },
        {
            name: 'Allegato generico',
            value: Number(AttachType.AllegatoGenerico)
        }
        // {
        //     name: 'Agevolazione Accise',
        //     value: Number(AttachType.AgevolazioneAccise)
        // }
    ];
    public checkallIdentity = false;
    public checkallContract = false;
    public customerVisibilityItems = [
        {
            name: 'Predefinita ruolo',
            value: CustomerVisibilityType.RoleBased
        },
        {
            name: 'Totale',
            value: CustomerVisibilityType.General
        }
    ];
    public permitContractsChoose = [
        {
            name: 'Per nessuno',
            value: ContractPermission.None
        },
        {
            name: 'Per se stesso',
            value: ContractPermission.Self
        },
        {
            name: 'Per i propri sottoposti',
            value: ContractPermission.Others
        },
        {
            name: 'Per tutti',
            value: ContractPermission.SelfAndOthers
        }
    ];
    public isLoadingAgencies = false;
    public _role = SessionStorageService.sessionInfo.role;
    public activeUserFilter: ISieveFilterObject;
    userFilter = SieveFilter.User.User;
    readonly contractDelayToleranceMin: number = 1;
    readonly contractDelayToleranceMax: number = 30;
    readonly contractDelayToleranceDefault: number = 10;
    usersRole: PataviumRole; // ruolo degli utenti nella lista

    public contractExportDetails = [];
    public readonly contractExportList = [
        {
            name: "Semplice",
            value: "simple"
        },
        {
            name: "Gas",
            value: "gg"
        },
        {
            name: "Energia",
            value: "ee"
        }
    ];

    constructor(
        protected toastr: ToastrService,
        protected dataService: DataService,
        protected modalService: NgbModal,
        protected modalConfig: NgbModalConfig,
        protected config: NgSelectConfig,
        protected notification: NotificationService,
        protected ptautocomplete: AutocompleteService,
        protected ngxService: NgxUiLoaderService,
        protected authService: AuthService,
        protected localStorage: LocalStorageService
    ) {
        super([], [], ptautocomplete, ngxService, localStorage);
        this.localStorageKey = LocalStorageKey.UserPageConfig;
        this.selectConf = {
            notFoundText: 'Nessun risultato'
        };
        this.modalConfig.backdrop = 'static';
        this.modalConfig.keyboard = false;
        // observable on errors
        this.loadConfiguration();

        this.userlistSubscription = new Subscription();
        // available brands depending on user.
        const _brands = JSON.parse(
            SessionStorageService.brands.get()
        ) as BrandType[];
        const nameBrand = {};
        nameBrand[BrandType.Patavium] = 'PATAVIUM';
        nameBrand[BrandType.Ajo] = 'AJO';
        nameBrand[BrandType.UniEnergia] = 'UNI ENERGIA';
        nameBrand[BrandType.AjoEnergia] = 'AJO ENERGIA';
        _brands.forEach(b => {
            this.brandAvailable.push({
                name: nameBrand[b],
                value: b
            });
        });
    }

    protected loadConfiguration(): IPageConfig {
        const pageConfig = super.loadConfiguration();
        if (pageConfig && pageConfig.filters) {
            this.activeUserFilter = pageConfig.filters[0];
        }
        return pageConfig;
    }

    ngOnInit() {
        super.ngOnInit();
        this.initData();
        this.availableGroups = [];
    }

    initData() {
        this.isInitFinished = false;
        this.updatePageConfig();
        //childsToLink
        const userString = new SieveString(this.sieveConf);
        userString.addFilters([
            {
                key: SieveFilter.User.Role,
                operator: SieveOperator.Equal,
                value: this.usersRole
            }
        ]);
        if (this.activeUserFilter) {
            userString.addFilters([this.activeUserFilter]);
            this.showBanUsers = false;
        } else {
            this.showBanUsers = true;
        }
        this.dataService
            .getUsers(userString)
            .pipe(
                tap(res => {
                    this.rows = res.total;
                    this.users = res.payload;
                }),
                catchError(err => {
                    console.error(err);
                    this.toastr.error(
                        `Si è verificato un errore cercando di accedere alla lista degli utenti`
                    );
                    this.rows = 0;
                    this.users = [];
                    return EMPTY;
                }),
                finalize(() => {
                    this.isInitFinished = true;
                })
            )
            .subscribe();
    }

    openModal(content: TemplateRef<any>, action: ActionUser, user: IUserWithAnagraphic) {
        this.isSavingUser = false;
        this.checkallIdentity = false;
        this.checkallContract = false;
        this.optAttachmentsIdentitySelected = [];
        this.optAttachmentsContractSelected = [];
        this.brandAvailableSelected = [];
        this.contractExportDetails = [];
        switch (action) {
            case ActionUser.Create:
                this.createUser = new UserInfoCreate();
                this.createUser.canExportContract = null;
                this.createUser.customerVisibility = CustomerVisibilityType.RoleBased;
                this.createUser.idRole = this.hisRole;
                this.createUser.idGroup = this.preferredGroup;
                this.createUser.anagraphicUser.anagraphicType = this.heIsAgency ? AnagraphicType.Company : AnagraphicType.Person;
                this.createUser.password = this.getPseudoRandomPassword();
                this.createUser.canStopContracts = false;
                break;
            case ActionUser.Edit:
                this.editUser = UserWithAnagraphicGroup.fromUserWithAnagraphic(user);
                if (
                    this.editUser.user.optionalContractAttaches &&
                    this.editUser.user.optionalContractAttaches.length
                ) {
                    this.editUser.user.optionalContractAttaches.forEach(opt => {
                        const elFoundIdentity = this.optAttachmentsIdentity.find(
                            el => el.value === opt
                        );
                        if (elFoundIdentity) {
                            this.optAttachmentsIdentitySelected.push(elFoundIdentity);
                        } else {
                            const elFoundContract = this.optAttachmentsContract.find(
                                el => el.value === opt
                            );
                            if (elFoundContract) {
                                this.optAttachmentsContractSelected.push(elFoundContract);
                            }
                        }
                    });
                    this.checkallContract =
                        this.optAttachmentsContractSelected.length ===
                        this.optAttachmentsContractSelected.length;
                    this.checkallIdentity =
                        this.optAttachmentsIdentitySelected.length ===
                        this.optAttachmentsIdentity.length;
                }
                if (this.editUser.user.permitBrands && this.editUser.user.permitBrands.length) {
                    this.editUser.user.permitBrands.forEach(e => {
                        const elFound = this.brandAvailable.find(o => o.value === e);
                        if (elFound) {
                            this.brandAvailableSelected.push(elFound);
                        }
                    });
                }
                if (this.editUser.user.canExportContract) {

                    if (this.editUser.user.canDoExportSemplice !== false) this.contractExportDetails.push({ name: "Semplice", value: "simple" });

                    if (this.editUser.user.canDoExportGas !== false) this.contractExportDetails.push({ name: "Gas", value: "gg" });

                    if (this.editUser.user.canDoExportEe !== false) this.contractExportDetails.push({ name: "Energia", value: "ee" });

                }
                break;
            case ActionUser.Info:
                this.infoUser = user;
                this.infoIdentityAttLabel = [];
                for (const el of this.infoUser.optionalAttachments) {
                    const lab = this.getOptionalIdentityAttachmentsLabel(el);
                    if (lab != null) {
                        this.infoIdentityAttLabel.push(lab);
                    }
                }
                this.infoContractAttLabel = [];
                for (const el of this.infoUser.optionalAttachments) {
                    const lab = this.getOptionalContractAttachmentLabel(el);
                    if (lab != null) {
                        this.infoIdentityAttLabel.push(lab);
                    }
                }
                break;
            case ActionUser.Link:
                this.linkUser = user;
                this.getLinkedCustomersForUser(this.linkUser.user.id);
                break;
        }
        this.modalRef = this.modalService.open(content, {
            centered: true,
            size: 'lg',
            windowClass: 'modal-xxl'
        });
    }

    closeModal() {
        this.linkedCustomers = null;
        this.checkAll = false;
        this.progressLink = null;
        this.isInLoad = false;
        this.modalService.dismissAll();
    }

    updateUser(): void {
        if (!this.editUser) {
            this.toastr.error(`Non è stato trovato l'utente da salvare`);
            return;
        }
        this.isSavingUser = true;
        const optAttachments = this.optAttachmentsIdentitySelected.concat(
            this.optAttachmentsContractSelected);
        if (optAttachments) {
            this.editUser.user.optionalContractAttaches = optAttachments.map(o =>
                Number(o.value)
            );
        }
        if (this.brandAvailableSelected) {
            this.editUser.user.permitBrands = this.brandAvailableSelected.map(o =>
                Number(o.value)
            );
        }

        if (this.editUser.user.canExportContract) {

            if (this.contractExportDetails.find((exp) => { return exp.value === "simple" })) {

                this.editUser.user.canDoExportSemplice = true;

            } else {

                this.editUser.user.canDoExportSemplice = false;

            }

            if (this.contractExportDetails.find((exp) => { return exp.value === "gg" })) {

                this.editUser.user.canDoExportGas = true;

            } else {

                this.editUser.user.canDoExportGas = false;

            }

            if (this.contractExportDetails.find((exp) => { return exp.value === "ee" })) {

                this.editUser.user.canDoExportEe = true;

            } else {

                this.editUser.user.canDoExportEe = false;

            }

        }

        //backward compatibility
        this.editUser.user.email = this.editUser.anagraphicUser.email;
        this.editUser.user.firstName = this.editUser.anagraphicUser.firstName;
        this.editUser.user.lastName = this.editUser.anagraphicUser.lastName;
        if (this.preferredPermitContract !== null) {
            this.editUser.user.permissionContractsType = this.preferredPermitContract;
        }
        this.dataService.updateUser(this.editUser)
            .pipe(
                tap(result => {
                    this.isSavingUser = false;
                    this.initData();
                    this.toastr.success(
                        'Profilo ' +
                        this.getSingleRoleName(this.usersRole) +
                        ' aggiornato correttamente',
                        'Successo',
                        { closeButton: true }
                    );
                    this.closeModal();
                }),
                catchError(err => {
                    console.error(`Error trying to update user`, err);
                    this.toastr.error(`Si è verificato un errore nel tentativo di salvare l'utente`);
                    this.isSavingUser = false;
                    return EMPTY;
                })
            ).subscribe();
    }

    saveNewUser(): void {
        if (!this.createUser) {
            this.toastr.error(`Non è stato trovato l'utente da salvare`);
            return;
        }
        this.isSavingUser = true;
        const optAttachments = this.optAttachmentsIdentitySelected.concat(
            this.optAttachmentsContractSelected);
        if (optAttachments) {
            this.createUser.optionalContractAttaches = optAttachments.map(o =>
                Number(o.value)
            );
        }
        if (this.brandAvailableSelected) {
            this.createUser.permitBrands = this.brandAvailableSelected.map(o =>
                Number(o.value)
            );
        }

        if (this.createUser.canExportContract) {

            if (this.contractExportDetails.find((exp) => { return exp.value === "simple" })) this.createUser.canDoExportSemplice = true;

            if (this.contractExportDetails.find((exp) => { return exp.value === "gg" })) this.createUser.canDoExportGas = true;

            if (this.contractExportDetails.find((exp) => { return exp.value === "ee" })) this.createUser.canDoExportEe = true;

        }

        //backward compatibility
        this.createUser.email = this.createUser.anagraphicUser.email;
        this.createUser.firstName = this.createUser.anagraphicUser.firstName;
        this.createUser.lastName = this.createUser.anagraphicUser.lastName;
        if (this.preferredPermitContract !== null) {
            this.createUser.permissionContractsType = this.preferredPermitContract;
        }
        this.dataService
            .createUser(this.createUser)
            .pipe(
                tap(result => {
                    this.toastr.success(
                        `Creazione ${this.getSingleRoleName(
                            this.usersRole
                        )} correttamente avvenuta`,
                        'Successo',
                        { closeButton: true }
                    );
                    this.closeModal();
                    this.initData();
                }),
                catchError(err => {
                    console.error(err);
                    this.toastr.error(
                        `Si è verificato un errore tentando di salvare l'utente`
                    );
                    return EMPTY;
                }),
                finalize(() => {
                    this.isSavingUser = false;
                })
            )
            .subscribe();
    }

    confirmRemoveUser(id) {
        if (id) {
            this.dataService.removeUser(id).subscribe(
                result => {
                    this.initData();
                    this.toastr.success('Utente rimosso dal sistema', 'Successo', {
                        closeButton: true
                    });
                    this.closeModal();
                },
                err => { }
            );
        }
    }

    enableOrDisableUser(id: number, enabled: boolean) {
        if (id) {
            this.dataService.enableOrDisableUser(id, enabled).subscribe(
                result => {
                    this.initData();
                },
                err => { }
            );
        }
    }

    customFilterConfiguration(pageConfig: IPageConfig): IPageConfig {
        if (pageConfig) {
            if (this.activeUserFilter) {
                pageConfig.filters = [this.activeUserFilter];
            } else {
                pageConfig.filters = [];
            }
        }
        return pageConfig;
    }

    get isRoleWithPermission(): boolean {
        return this.heIsAgency || this.heIsAgencyOperator || this.heIsBackofficeOperator;
    }

    get roleNoNeedCf(): boolean {
        return this.heIsAgency || this.heIsAgencyOperator || this.heIsBackofficeOperator;
    }

    get canChooseExportContract(): boolean {
        return true;
    }

    setFilterDisabledUser(toShow: boolean) {
        if (!toShow) {
            this.activeUserFilter = {
                key: SieveFilter.User.IsDisabled,
                operator: SieveOperator.Equal,
                value: false
            };
        } else {
            this.activeUserFilter = null;
        }
        this.initData();
    }
    getOptionalIdentityAttachmentsLabel(value: AttachType) {
        for (const el of this.optAttachmentsIdentity) {
            if (el.value === value) {
                return el.name;
            }
        }
        return null;
    }
    getOptionalContractAttachmentLabel(value: AttachType) {
        for (const el of this.optAttachmentsContract) {
            if (el.value === value) {
                return el.name;
            }
        }
        return null;
    }

    askForPasswordReset(user: IUserWithAnagraphic | IUserWithAnagraphicGroup) {
        const id = user.user.id.toString();
        return this.authService.askForPasswordReset(id).subscribe(response => {
            this.toastr.success(
                `È stato richiesto il reset della password per l'utente ${id}`,
                'Successo'
            );
            this.closeModal();
        });
    }

    // my properties
    get iAmPataviumOperator() {
        return this._role === PataviumRole.BackOfficeOperator;
    }
    get iAmSuperadmin() {
        return this._role === PataviumRole.Admin;
    }
    get iAmAgent() {
        return this._role === PataviumRole.Agent;
    }
    get iAmAgency() {
        return this._role === PataviumRole.Agency;
    }



    // his properties
    get hisRole(): PataviumRole {
        return this.usersRole;
    }
    get heIsBackofficeOperator(): boolean {
        return this.usersRole === PataviumRole.BackOfficeOperator;
    }
    get heIsSpecializedOperator(): boolean {
        return this.hisRole === PataviumRole.SpecializedOperator;
    }
    get heIsAgency(): boolean {
        return this.hisRole === PataviumRole.Agency;
    }
    get heIsAgencyOperator(): boolean {
        return this.hisRole === PataviumRole.AgencyOperator;
    }
    get heIsAgent() {
        return this.hisRole === PataviumRole.Agent;
    }

    //VISIBILITY
    get showAgencySelection() {
        return (
            (this.usersRole === PataviumRole.Agent || this.usersRole === PataviumRole.AgencyOperator) &&
            (this._role === PataviumRole.BackOfficeOperator || this._role === PataviumRole.Admin)
        );
    }

    //AUTOCOMPLETE
    fooSearch(term: string, item: any) {
        return true;
    }
    async setAgencies(userInput: string): Promise<void> {
        this.isLoadingAgencies = true;
        const agencyString = new SieveString();
        agencyString.addFilters([
            {
                key: SieveFilter.User.Role,
                operator: SieveOperator.Equal,
                value: PataviumRole.Agency
            },
            {
                key: SieveFilter.User.User,
                operator: SieveOperator.Contains,
                value: userInput || 'a'
            }
        ]);
        this.availableGroups = await new Promise<IVeryShortUser[]>(executor => {
            this.dataService.getSuggestUsers(agencyString).subscribe(response => {
                executor(response.payload);
            });
        });
        this.isLoadingAgencies = false;
    }

    //RANDOM PASSWORD
    getPseudoRandomPassword() {
        const password =
            'aA1' +
            Math.random()
                .toString(36)
                .slice(2);
        return password;
    }

    // unlink customers
    toggleCheckAll() {

        if (this.checkAll === false) {

            this.linkedCustomers.map(customer => {
                customer.status = false;
            });

        } else {

            this.linkedCustomers.map(customer => {
                customer.status = true;
            });

        }
    }

    // get linked customers
    async getLinkedCustomersForUser(userId) {
        await new Promise<IPairAnagraphicUserRole[]>(executor =>
            this.dataService.getLinkedCustomersForUser(userId).subscribe(response => {
                this.linkedCustomers = response.payload;
                executor(response.payload);
            })
        );
    }

    async confirmUnlink() {

        try {

            const toUnlink = this.linkedCustomers.filter((customer) => {
                return customer.status === true;
            });

            if (toUnlink.length === 0) {

                this.toastr.warning("E' necessario selezionare almeno un elemento da dissociare", "Attenzione");
                return;
            }

            let doneCall = 0;
            const totalCall = toUnlink.length * 2;
            this.isInLoad = true;

            for (let i = 0; i < toUnlink.length; i++) {

                try {
                    await this.dataService
                        .unlinkCustomer(toUnlink[i].idClient, toUnlink[i].idUser)
                        .pipe(take(1))
                        .toPromise();
                    doneCall++;
                    this.progressLink = Math.ceil((doneCall / totalCall) * 100);
                } catch {
                    this.progressLink = null;
                    this.isInLoad = false;
                    return;
                }

            }
            await this.initData();
            await this.toastr.success('Clienti dissociati correttamente', 'Successo', {
                closeButton: true
            });
            await this.closeModal();

        } catch (e) {

            this.toastr.error("Errore durante l\'operazione", "Errore");

        }

    }

}



// WEBPACK FOOTER //
// ./src/app/pages/common/userlist/userlist.component.ts